<script>
    export default {
        computed: {
            fileID() {return this.$store.getters.CURRENT_FILE_ID}
        },
        methods: {
            async changeID(event) {
                const value = event.target.value;
                this.$store.commit('CURRENT_FILE_ID', value);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>File ID:</label>
        <input 
            @change="changeID"
            :value="fileID"
            class="right_input mt_5"
            type="number"
        >
    </div>
</template>